export const endpoints = {
  updateSignupFlow: '/companies/{id}/onboarding',
} as const;
